import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { ContentTopBar } from 'components';
import { useGetTipsadvice } from 'features/events/use-cases/get-tips-advice';
import { usePermissions } from 'features/users';
import { usePaginationParams } from 'hooks';
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';

import { EventsFilterFormValues } from '../../events-filter-form';
import { AddTipsModal } from '../event-tips-advice/add-tips-modal/add-tips-modal';
import { TipsAdviceTable } from '../event-tips-advice/tips-advice-table';



const TipsAdviceComponent = ({ tabs }: { tabs: string }) => {
  const { id } = useParams();
  const initialFilterValues: EventsFilterFormValues = {
    field_name: undefined,
  };


  const permissions = usePermissions();
  const { params, updateParams } =
    usePaginationParams<any>({
      page: 1,
      size: 10,
      order_by: '-rank',
      event_id: id,
      ...initialFilterValues,
    });
  const { data, isFetching, refetch } = useGetTipsadvice(params);
  const shouldHandleFieldCreation = permissions?.fields.add;
  const [showAddEventModal, setShowAddEventModal] = useState<boolean>(false);
  const [outletdata, setOutletdata] = useState(undefined)

  const handleCloseModal = () => {
    setShowAddEventModal(false);
    document.body.style.overflow = 'visible';
  }


  const handleOpenModal = () => {
    setShowAddEventModal(true);
    setOutletdata(undefined)
    document.body.style.overflow = 'hidden';
  }

  useEffect(() => {
    if (tabs === "5") {
      refetch();
    }
  }, [tabs]);

  return (
    <>
      <ContentTopBar
        title={''}
        renderButtons={
          <>
            {shouldHandleFieldCreation ? (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                <Button
                  icon={<PlusOutlined />}
                  onClick={handleOpenModal}
                >
                  Add Tips
                </Button>
                <div className={`cstmrightmdl ${showAddEventModal && "show"}`}>
                  <AddTipsModal id={id} showAddEventModal={showAddEventModal} outletdata={outletdata} refetch={refetch} onClose={handleCloseModal} />
                </div>

              </div>
            ) : null}
          </>
        }
      />
      <TipsAdviceTable
        id={id}
        data={data}
        isLoading={isFetching}
        tableParams={params}
        updateParams={updateParams}
        refetch={refetch}
        setOutletdata={setOutletdata}
        outletdata={outletdata}
      />
    </>
  )
}

export default TipsAdviceComponent;
